// src/app/interceptors/policyEnforcement.ts
//
// Intercepts 403 POLICY_ACCEPTANCE_REQUIRED responses and opens the
// acceptance modal rather than propagating the error.
//
// Lives in `app/` (not `shared/`) because it imports from `features/` —
// which is above `shared` in the FSD layer hierarchy. The `app` layer is
// allowed to import from every layer below it.
import { axiosInstance } from '@/shared/api';
import { usePolicyAcceptanceModal } from '@/features/policy-acceptance';

axiosInstance.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    const response = (error as {
      response?: {
        status?: number;
        data?: {
          code?: string;
          details?: { pendingPolicyAcceptances?: Array<{
            policyId: string;
            documentType: 'PRIVACY_POLICY' | 'TERMS_AND_CONDITIONS';
            versionNumber: number;
            title: string;
          }> };
        };
      };
    })
      ?.response;

    if (
      response?.status === 403 &&
      response?.data?.code === 'POLICY_ACCEPTANCE_REQUIRED'
    ) {
      usePolicyAcceptanceModal
        .getState()
        .open(
          'interceptor',
          response.data?.details?.pendingPolicyAcceptances ?? [],
        );
      return Promise.reject(error);
    }

    return Promise.reject(error);
  },
);
